module.exports = __webpack_public_path__ + "media/bootstrap-icons/tablet-landscape-fill-5142de04.svg";